import LogbookHandover from "../common/logbook-transfer";

export default function OwnerLogbookTransfer() {
  return <LogbookHandover />;
}
